'use client';

import {
	Card,
	Stack,
	Text,
} from '@chakra-ui/react';

import type { CardRootProps } from '@chakra-ui/react';
import { NextImageWithSkeleton } from '@packages/chakra-v3';
import { useLocale } from 'next-intl';
import type { ListCollectionsResponse } from '../../react-query';
import { DefaultStyle } from '@packages/wastic-shared';

type CollectionCardProps =  CardRootProps & {
	collection: ListCollectionsResponse['collections'][number];
};

const CollectionCard = ({
	collection,
	...rest
}: CollectionCardProps) => {
	const locale = useLocale() as 'en' | 'th';
	const shortDescription = collection.shortDescription ? (collection.shortDescription as never)[locale] : '';

	return (
		<Card.Root
			borderRadius={0}
			overflow={'hidden'}
			p={0}
			position={'relative'}
			{...rest}
		>
			<NextImageWithSkeleton
				alt={collection.name}
				aspectRatio={'landscape'}
				src={collection.image ?? ''}
			/>
			<Stack
				bg={'rgba(202, 191, 191, 0.25)'}
				bottom={0}
				gap={0}
				layerStyle={'white'}
				left={0}
				position={'absolute'}
				px={DefaultStyle.SMALL_GAP}
				py={2}
				w={'full'}
			>
				<Text fontSize={'22px'} fontWeight={800}>{collection.name}</Text>
				<Text fontSize={'16px'} fontWeight={600}>{shortDescription}</Text>
			</Stack>
		</Card.Root>
	);
};

export default CollectionCard;